// French banks and insurers with locally stored logos (public/brands/org-<slug>.png, taken from each brand's own site icon)
const LIST = [
  ["bnp", "BNP Paribas"], ["socgen", "Société Générale"], ["ca", "Crédit Agricole"], ["lcl", "LCL"], ["cde", "Caisse d'Épargne"],
  ["bpop", "Banque Populaire"], ["cmut", "Crédit Mutuel"], ["cic", "CIC"], ["lbp", "La Banque Postale"], ["bourso", "BoursoBank"],
  ["hello", "Hello bank!"], ["fortuneo", "Fortuneo"], ["monabanq", "Monabanq"], ["hsbc", "HSBC"], ["axabq", "AXA Banque"],
  ["revolut", "Revolut"], ["n26", "N26"], ["qonto", "Qonto"], ["shine", "Shine"],
];
const INSURERS_LIST = [
  ["axa", "AXA"], ["maif", "MAIF"], ["macif", "MACIF"], ["maaf", "MAAF"], ["allianz", "Allianz"], ["groupama", "Groupama"],
  ["generali", "Generali"], ["matmut", "Matmut"], ["gmf", "GMF"], ["mma", "MMA"], ["direct", "Direct Assurance"], ["april", "April"],
  ["leocare", "Leocare"], ["hiscox", "Hiscox"], ["swisslife", "Swiss Life"],
];
export const BANKS = LIST.map(([slug, name]) => ({ slug, name }));
export const INSURERS = INSURERS_LIST.map(([slug, name]) => ({ slug, name }));

const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");
const BY_NAME = Object.fromEntries([...LIST, ...INSURERS_LIST].map(([slug, name]) => [norm(name), slug]));
export const orgSlug = (name) => BY_NAME[norm(name)] || Object.entries(BY_NAME).find(([k]) => k.length > 2 && norm(name).startsWith(k))?.[1] || null;

const PALETTE = ["#87B8A5", "#D8BD78", "#9DB4D8", "#C9A6D8", "#E3A79A", "#1F2A44"];

export const OrgLogo = ({ slug, name, className = "h-8 w-8" }) => {
  const s = slug || orgSlug(name);
  const initials = (name || "?").replace(/\(.*\)/, "").split(/[\s'’-]+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();
  const bg = PALETTE[[...(name || "")].reduce((a, c) => a + c.charCodeAt(0), 0) % PALETTE.length];
  return (
    <span className={`relative flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-white shadow-sm ring-1 ring-black/5 ${className}`} data-testid="org-logo">
      <span className="absolute inset-0 flex items-center justify-center text-[11px] font-bold text-white" style={{ background: bg }}>{initials}</span>
      {s && <img src={`/brands/org-${s}.png`} alt={name} className="relative h-full w-full bg-white object-contain p-1" onError={(e) => { e.currentTarget.style.display = "none"; }} />}
    </span>
  );
};
